import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

// Shared wrapper for legal pages (Mentions légales, CGV, RGPD, Cookies)
export const LegalPageLayout = ({ title, children }) => {
  return (
    <div className="pt-20 min-h-screen bg-[#F5F2EA]" data-testid={`legal-page-${title}`}>
      <section className="bg-white py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#57534E] hover:text-[#C62E2E] mb-6 text-sm"
          >
            <ChevronLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1917] mb-2">
            {title}
          </h1>
          <p className="text-[#57534E] text-sm">
            Dernière mise à jour :{' '}
            {new Date().toLocaleDateString('fr-BE', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="prose prose-stone max-w-none bg-white rounded-2xl p-8 md:p-12 shadow-sm legal-article">
            {children}
          </article>
        </div>
      </section>
    </div>
  );
};

export const COMPANY_INFO = {
  name: 'SRL Merc & Co',
  tradeName: 'NotaBene Sympho',
  legalForm: 'Société à Responsabilité Limitée (SRL)',
  bce: 'BE 0630.876.815',
  vat: 'BE 0630.876.815',
  address: 'Chaussée du Roi Baudouin 161, 7030 Mons, Belgique',
  phone: '+32 65 95 06 49',
  email: 'notabene.mons@gmail.com',
  publisher: 'SRL Merc & Co',
  hosting: 'Emergent Agent (Kubernetes Cloud) — emergentagent.com',
};
